import { defineStore } from "pinia";
import { Cms } from "@/models/api/cms.model";
import { ref } from "vue";
import API from "@/api";

export const useCmsStore = defineStore("cms", () => {
  const cms = ref<Cms[]>([]);
  const areCmsLoading = ref(true);
  const populateCms = () => {
    return API.cms.getCms().then((response: Cms[]) => {
      cms.value = response;
      areCmsLoading.value = false;
    });
  };

  const populateCmsUrl = (cmsId: number) => {
    return API.cms
      .getCmsUrl(cmsId)
      .then(response => {
        return response;
      })
      .catch(error => {
        throw error;
      });
  };

  return {
    cms,
    areCmsLoading,
    populateCms,
    populateCmsUrl
  };
});
